<div class="container-fluid" style="background-color: #F5F5F7;">

    <div class="auto">
        <div class="page-wrapper">
            <div class="card">

                <h2 class="title">GST Registration </h2>
                <p class="subtitle">
                    Let us know about your GST registration status
                </p>

                <label class="">
                    Are you GST registered? <span class="required">*</span>
                </label>

                <div class="button-group">
                    <button type="button" class="option-btn" [class.selected]="isRegistered === true"
                        (click)="selectOption(true)" *ngIf="!onlyhideYes">
                        Yes, I am GST registered
                    </button>

                    <button type="button" class="option-btn" [class.selected]="isRegistered === false"
                        (click)="selectOption(false)" [disabled]="isAgreed" *ngIf="!formfillNext">
                        No, I am not registered
                    </button>
                    
                </div>
                <ng-container *ngIf="!isNotRegistered">
                    <form [formGroup]="legalForm" (ngSubmit)="submit()">

                        <div class="form-row">
                            <div class="form-group">
                                <label>GST Number <span class="required">*</span></label>
                                <input type="text" formControlName="gstNumber" placeholder="27ABCDE1234F2Z5"
                                    maxlength="15" (input)="onGstInput($event)" />
                                <div *ngIf="legalForm.get('gstNumber')?.touched && legalForm.get('gstNumber')?.invalid">
                                    <small class="error" *ngIf="legalForm.get('gstNumber')?.errors?.['required']">GST
                                        number
                                        required</small>
                                    <small class="error" *ngIf="legalForm.get('gstNumber')?.errors?.['minlength']">GST
                                        number must be
                                        15
                                        characters</small>
                                    <small class="error" *ngIf="legalForm.get('gstNumber')?.errors?.['pattern']">Invalid
                                        GST number
                                        format</small>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label>GST Certificate <span class="required">*</span></label>
                            <input type="file" (change)="onFileSelect($event)" hidden
                                accept="image/*,application/pdf,.png,.jpg,.jpeg" id="panFile" />
                            <div class="file-box">
                                <span class="file-name" *ngIf="!formfillNext">
                                    <!-- {{ selectedFileName?.slice(0, 20) || 'Choose file...' }}    -->

                                    {{
                                    selectedFileName
                                    ? (
                                    selectedFileName.length > 20
                                    ? (selectedFileName.slice(0,20) + '' +
                                    selectedFileName.slice(selectedFileName.lastIndexOf('.')))
                                    : selectedFileName
                                    )
                                    : 'Choose file...'
                                    }}
                                </span>

                                <span class="file-name" *ngIf="formfillNext">
                                    <a [href]=selectedFileName target="_blank" style="text-decoration: none;">VIEW
                                        CERTIFICATE</a>
                                </span>

                                <button type="button" class="browse-btn" (click)="triggerFile()" *ngIf="!formfillNext">
                                    Browse
                                </button>
                            </div>
                            <div class="error"
                                *ngIf="legalForm.get('gstFile')?.touched && legalForm.get('gstFile')?.invalid">
                                <small class="error" *ngIf="legalForm.get('gstFile')?.errors?.['required']">
                                    GST certificate is required
                                </small>

                                <small *ngIf="legalForm.get('gstFile')?.errors?.['invalidType']">
                                    Only PDF, JPG, PNG files allowed
                                </small>

                                <small *ngIf="legalForm.get('gstFile')?.errors?.['maxSize']">
                                    File size must be less than 3MB
                                </small>

                                <small *ngIf="legalForm.get('gstFile')?.errors?.['uploadFailed']">
                                    File upload failed, please try again
                                </small>
                            </div>
                        </div>
                          <div class="note-box">
          <strong>Note:</strong>
          Please ensure the  GST copy is clear and all details are readable.
          Accepted formats: JPG, PNG, PDF (max 3MB)
        </div>

                        <!-- Buttons -->
                        <div class="button-row">
                            <button type="button" class="secondary-btn" (click)="back()" *ngIf="showSecondaryBtn">
                                Back
                            </button>

                            <button type="submit" class="primary-btn" *ngIf="!formfillNext"> Continue </button>
                            <button type="button" class="primary-btn" (click)="next()" *ngIf="formfillNext"> Next
                            </button>
                        </div>


                    </form>
                </ng-container>
                <ng-container *ngIf="isNotRegistered">
                    <div class="undertaking-box">
                        <h4>Non-GST Registration Undertaking</h4>

                        <p>
                            I hereby declare that I am not registered under GST and undertake to inform
                            the platform immediately upon obtaining GST registration in the future.
                            I understand that GST compliance is my responsibility.
                        </p>

                        <!-- <p class="agreement">
                    I have read and agree to the undertaking stated above
                </p> -->

                        <div class="agreement">

                            <input type="checkbox" [(ngModel)]="isAgreed" (change)="onAgreementChange($event)" [disabled]="isAgreed"/>
                            <span> I have read and agree to the undertaking stated above</span>

                        </div>


                    </div>
                    <div class="button-row">
                        <button type="button" class="secondary-btn" (click)="back()" *ngIf="showSecondaryBtn">
                            Back
                        </button>

                        <button type="button" class="primary-btn " (click)="submitAgree()" [disabled]="!isAgreed">
                            {{ isAgreed ? 'Next' : 'Continue' }}
                        </button>
                    </div>
                </ng-container>


            </div>

            <div class="step-dots">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot active"></span>
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
            </div>
        </div>
    </div>
    <div class="logout">
        <button (click)="logout()" class="primary-btn">Logout</button>
    </div>

</div>